import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {getAppInfo} from "../../../actions/sideBar.actions";
import {showModal} from "src/actions/modal.actions";
import {
    CamModuleMenu,
    DashboardModuleMenu,
    OperModuleMenu,
    ReportModuleMenu,
    SettingModuleMenu,
    AdministrationModuleMenu,
    OperationModuleMenu,
} from './MenuModules';
import {getSideBar} from "src/selectors";
import {connect} from "react-redux";

class SideBar extends Component {

    state = {
        activeMenu: '',
        selectedOption: null,
    };

    componentDidMount() {
        this.props.getAppInfo()
    }

    changeActiveMenu = (menu) => {
        this.setState({
            activeMenu: this.state.activeMenu !== menu ? menu : ''
        });
    };

    releaseNotesConfigValue = (releaseNotesDisabled) => {
        if(releaseNotesDisabled) {
            let boolValue = true;

            if (releaseNotesDisabled.toLowerCase() === "false") {
                boolValue = false;
            }
            return boolValue
        } else {
            //If no release notes config then we set button to disabled by default
            return true
        }
    }

    trimVersion = (versionNumber) => {
        /**We trim the version number to include only major+minor versions to send in a GET request for Wordpress Release Notes **/
        let versionArray = versionNumber.split(".")
        let modifiedVersionNumber = versionArray.slice(0, versionArray.length - 1).join(".")
        return modifiedVersionNumber
    }

    trimVersion = (versionNumber) => {
        /**We trim the version number to include only major+minor versions to send in a GET request for Wordpress Release Notes **/
        let versionArray = versionNumber.split(".")
        let modifiedVersionNumber = versionArray.slice(0, versionArray.length - 1).join(".")
        return modifiedVersionNumber
    }

    renderMainMenu = (menuItem) => {
        const {activeMenu} = this.state;
        const {userPermission, dashboardMenuCount, reportCategories} = this.props;

        let modulePermisions;

        switch (menuItem) {
            case 'SHOW_MENU_CAM':
                modulePermisions =
                    userPermission.find((x) => x.name === 'CAM') &&
                    userPermission.find((x) => x.name === 'CAM').permissions;
                return (
                    <CamModuleMenu
                        key={'CamModuleMenu'}
                        activeMenu={activeMenu}
                        changeActiveMenu={this.changeActiveMenu}
                        permissions={modulePermisions}
                    />
                );
            // case 'SHOW_MENU_DASH':
            // 	modulePermisions =
            // 		userPermission.find((x) => x.name === 'DASH') &&
            // 		userPermission.find((x) => x.name === 'DASH').permissions;
            // 	return (
            // 		<DashboardModuleMenu
            //          key={'DashboardModuleMenu'}
            // 			activeMenu={activeMenu}
            // 			changeActiveMenu={this.changeActiveMenu}
            // 			permissions={modulePermisions}
            // 		/>
            // 	);
            case 'SHOW_MENU_OPR':
                modulePermisions =
                    userPermission.find((x) => x.name === 'OPER') &&
                    userPermission.find((x) => x.name === 'OPER').permissions;
                return (
                    <OperModuleMenu
                        key={'OperModuleMenu'}
                        activeMenu={activeMenu}
                        changeActiveMenu={this.changeActiveMenu}
                        permissions={modulePermisions}
                        dashboardMenuCount={dashboardMenuCount}
                    />
                );
            default:
                return null;
        }
    };

    render() {

        const {activeMenu} = this.state;
        const {userPermission, appInfo, reportCategories, releaseNotesDisabled} = this.props;

        const userPermissionMenu = userPermission.find((permision) => permision.name === 'WEB_MENU');

        const settingsPermissions = userPermission.map((modulePermission) => modulePermission.permissions).flat();

        return (
            <nav id="sidebar" className="sidebar-wrapper show">
                <div className="sidebar-content">

                    <div className="sidebar-menu">

                        <ul>
                            <li className="header-menu">
                                <span>Main</span>
                            </li>
                            <li className="active">
                                <Link to={{pathname: '/home'}}>
                                    <i className="fa fa-home"/>
                                    <span>Home</span>
                                </Link>
                            </li>
                            {userPermissionMenu.permissions.map((menu) => this.renderMainMenu(menu))}
                        </ul>

                        <OperationModuleMenu
                            activeMenu={activeMenu}
                            changeActiveMenu={this.changeActiveMenu}
                            permissions={settingsPermissions}
                            userPermissionMenu={userPermissionMenu}
                        />

                        {userPermissionMenu.permissions.includes('SHOW_MENU_ADMIN') && (
                        <AdministrationModuleMenu
                            key={'AdministrationModuleMenu'}
                            activeMenu={activeMenu}
                            changeActiveMenu={this.changeActiveMenu}
                            permissions={settingsPermissions}
                            userPermissionMenu={userPermissionMenu}
                        />
                        )}

                        {userPermissionMenu.permissions.includes('SHOW_MENU_REP') &&
                        <ReportModuleMenu
                            key={'ReportModuleMenu'}
                            activeMenu={activeMenu}
                            changeActiveMenu={this.changeActiveMenu}
                            reportCategories={reportCategories}
                        />
                        }

                        <SettingModuleMenu
                            key={'SettingModuleMenu'}
                            activeMenu={activeMenu}
                            changeActiveMenu={this.changeActiveMenu}
                            permissions={settingsPermissions}
                            userPermission={userPermissionMenu}
                            appInfo={appInfo}
                        />

                    </div>

                    <div className="sidebar-footer">
                        <p className="sidebar-version">
                            {this.releaseNotesConfigValue(releaseNotesDisabled) ?
                                <span className="" style={{cursor:'pointer'}}>{appInfo.camvioVersion}</span>
                               :
                               <span className="" style={{cursor:'pointer'}} onClick={() => this.props.showModal('RELEASE_NOTES_MODAL', {releaseVersion:this.trimVersion(appInfo.camvioVersion)})}>
                                   {appInfo.camvioVersion}
                          </span>
                               }
                        </p>
                    </div>

                </div>
            </nav>
        );
    }
}

SideBar.propTypes = {
    userSummary: PropTypes.object,
    userPermission: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => {
    const appInfo = getSideBar(state).appInfo;
    const releaseNotesDisabled = state.user?.configuration.find((x) => x.key === "releaseNotes.disabled")?.value
    return {
        appInfo,
        releaseNotesDisabled
    };
};


const mapDispatchToProps = {
    getAppInfo,
    showModal
};


export default connect(mapStateToProps, mapDispatchToProps)(SideBar);
